module.exports = __webpack_public_path__ + "media/img/help_center/Student_Dashboard_03-e34feac7bf352428f0cd047a788b8d1d.jpg";